import React, { Fragment } from 'react';
import PropTypes from 'prop-types';


import Advice from 'src/components/Advice';
import advice from 'src/types/advice';
import SeeAllTile from 'src/components/SeeAllTile';


const AdvicesListing = ({ advices, categoryPath, advicesURL }) => {
  const tileTitle = 'Zobacz wszystkie porady z tej kategorii';
  const tileContent = 'Zobacz wszystkie';

  return (
    <Fragment>
      {
        advices
          .map(({
            title, lead, imageUrl, url
          }) => (
            <Advice
              key={ title }
              imageUrl={ imageUrl }
              lead={ lead }
              title={ title }
              url={ url }
            />
          ))
      }
      <SeeAllTile
        advicesURL={ advicesURL }
        categoryPath={ categoryPath }
        title={ tileTitle }
      >
        { tileContent }
      </SeeAllTile>
    </Fragment>
  );
};


AdvicesListing.propTypes = {
  advices: PropTypes.arrayOf(
    PropTypes.shape(advice)
  ).isRequired,
  advicesURL: PropTypes.string.isRequired,
  categoryPath: PropTypes.string.isRequired
};


export default AdvicesListing;
